export enum Route {
  Home = '/',
  Blog = '/blog',
  Tags = '/blog/tags',
}
